<div class="page-container" [class.loading]="isLoading">
    @if (employee(); as employee) {
        <app-header
            [title]="{ key: 'payroll.taxForms.RL1.employee.title', params: { name: employee.fullName } }"
            [back]="true"
            [backRoute]="backRoute() ?? ''"
            [menuService]="payrollModuleMenuService"
            [badgeOptions]="headerBadgeOptions"
            [contextMenu]="true"
        >
            @if (rl1.isOpen) {
                @if (rl1.isOriginal) {
                    <app-context-item
                        label="payroll.taxForms.revertToOriginal"
                        (click)="revertConfirmationDialog.open = true"
                    ></app-context-item>
                } @else {
                    <app-context-item label="delete" (click)="deleteConfirmationDialog.open = true"></app-context-item>
                }
            } @else {
                <app-context-item
                    [disabled]="!rl1.canSendEmails"
                    [matTooltip]="rl1.canSendEmails ? undefined : ('payroll.taxForms.RL1.cannotSend' | translate)"
                    matTooltipPosition="before"
                    label="payroll.taxForms.sendEmail"
                    (click)="handleSend(rl1)"
                ></app-context-item>
                <app-context-item label="download" (click)="handleDownload(rl1)"></app-context-item>
            }

            <div class="buttons">
                @if (canCreateAmendment()) {
                    <ui-button (click)="handleAddAmendment(rl1)" type="outline">{{
                        'payroll.taxForms.createAmendment' | translate
                    }}</ui-button>
                }

                <ui-button (click)="handlePreview(rl1)" type="primary">{{
                    'payroll.taxReturns.downloadPreview' | translate
                }}</ui-button>
            </div>
        </app-header>
    }
    <app-employee-tax-form-details [taxForm]="rl1" (onEditEmployee)="handleEditEmployee()" />
    <app-employee-tax-form-boxes [taxForm]="rl1" (onEditBoxes)="handleEditBoxes()" />
</div>

<ui-dialog
    #deleteConfirmationDialog
    header="payroll.taxForms.RL1.employee.delete.dialogTitle"
    confirmationDialog
    (closing)="deleteConfirmationDialog.open = false"
    (primaryButtonPressed)="handleDelete(rl1); deleteConfirmationDialog.open = false"
>
    <p>{{ 'payroll.taxForms.RL1.employee.delete.confirmation' | translate }}</p>
</ui-dialog>

<ui-dialog
    #revertConfirmationDialog
    header="payroll.taxForms.RL1.employee.revertToOriginal.dialogTitle"
    confirmationDialog
    (closing)="revertConfirmationDialog.open = false"
    (primaryButtonPressed)="handleRevert(); revertConfirmationDialog.open = false"
>
    <p>{{ 'payroll.taxForms.RL1.employee.revertToOriginal.confirmation' | translate }}</p>
</ui-dialog>

<app-tax-form-consent-dialog packageTypeToBeEmailed="RL1" [employeeName]="employee()?.fullName" />
